<template>
  <el-pagination
    :total="total"
    :current-page="page"
    :page-size="perPage"
    small
    background
    layout="prev, pager, next"
    @current-change="handleChangePage"
    class="mt-8"
  />
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'

defineProps({
  total: {
    type: Number,
    default: 0
  },
  page: {
    type: Number,
    default: 1
  },
  perPage: {
    type: Number,
    default: 1
  }
})

const emit = defineEmits(['changePage'])
const handleChangePage = (page) => {
  emit('changePage', page)
}
</script>
